import { useContext } from "react";

import { AppConfigContext } from "../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../core/data-access/useAuthorizedFetch";

export const useAdminEncodeCachingApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const { httpPost, httpGet } = useAuthorizedFetch();
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/encode-caching/`;

    const purge = async (): Promise<void> => {
        return httpPost(`${baseUrl}purge`);
    };

    const count = async (): Promise<{ count: number }> => {
        return httpGet(`${baseUrl}count`);
    };

    return {
        purge,
        count
    };
};
